var __jsx = React.createElement;
import React from 'react';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../../styles/rca/RCASearch.module.scss';

var CarListNew = function CarListNew(props) {
  var editStep = props.editStep;

  var handleStepChange = function handleStepChange() {
    editStep('new');
  };

  return __jsx(Col, {
    xs: 12,
    md: 4,
    className: 'p-3'
  }, __jsx(Card, {
    className: "".concat(styles.carItem)
  }, __jsx(Card.Body, {
    className: ""
  }, __jsx(Image, {
    src: "/images/icons/leasing-auto.png",
    alt: "Autovehicul nou",
    width: 100,
    height: 60
  }), __jsx("p", {
    className: styles.smallInfo
  }, "Adaug\u0103 o alt\u0103 ma\u0219in\u0103")), __jsx(Card.Footer, {
    className: "bg-white border-0"
  }, __jsx(Button, {
    className: "w-100",
    onClick: handleStepChange
  }, "Adaug\u0103 auto", __jsx(FontAwesomeIcon, {
    icon: faChevronRight,
    className: "ml-2",
    width: "16",
    height: "16"
  })))));
};

export default CarListNew;